import React, { useState } from 'react';
import axios from 'axios';
import { API_URLS } from '../../apiConfig';

//const API_BASE_URL = 'https://scagliacons.cloud/api/personas';

function EditPersonForm({ person, setEditingPerson, onUpdate }) { 
    const [formData, setFormData] = useState({
        id: person.id,
        nombre: person.nombre,
        apellido: person.apellido,
        direccion: person.direccion || '',
        correo: person.correo || '',
        numero_contacto: person.numero_contacto || '',
        rol: person.rol,
    });
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        setLoading(true);
        setError(null);

        try {
            await axios.put(`${API_URLS.PERSONAS}/${person.id}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            if (onUpdate) onUpdate(); 
            setEditingPerson(null); 
        } catch (err) {
            setError(err.response?.data?.message || 'Error al actualizar la persona.');
        } finally {
            setLoading(false);
        }
    };

    return (
        /* Overlay con desenfoque moderno */
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-fadeIn">
            <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-xl overflow-hidden border border-gray-100">
                
                {/* Header Estilo Corporativo (Gris Oscuro y Oro) */}
                <div className="bg-gray-900 p-6 text-white flex justify-between items-center">
                    <div>
                        <h3 className="text-xl font-bold flex items-center gap-2">
                            <i className="bi bi-person-gear text-[#FFD700]"></i>
                            Editar Perfil
                        </h3>
                        <p className="text-gray-400 text-[10px] uppercase tracking-widest mt-1">ID Usuario: {person.id}</p>
                    </div>
                    <button 
                        onClick={() => setEditingPerson(null)}
                        className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors"
                    >
                        <i className="bi bi-x-lg text-xl"></i>
                    </button>
                </div>

                <div className="p-8">
                    {error && (
                        <div className="bg-red-50 text-red-700 p-4 rounded-2xl mb-6 border border-red-100 flex items-center gap-3 animate-shake">
                            <i className="bi bi-exclamation-octagon-fill"></i>
                            <span className="text-sm font-medium">{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div className="flex flex-col">
                                <label className="label-modern">Nombre</label>
                                <input 
                                    type="text" 
                                    name="nombre"
                                    className="input-modern"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    required
                                    disabled={loading}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="label-modern">Apellido</label>
                                <input 
                                    type="text" 
                                    name="apellido"
                                    className="input-modern"
                                    value={formData.apellido}
                                    onChange={handleChange}
                                    required
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col">
                            <label className="label-modern">Dirección Particular</label>
                            <input 
                                type="text" 
                                name="direccion"
                                className="input-modern"
                                value={formData.direccion}
                                onChange={handleChange}
                                placeholder="Calle, Número, Ciudad"
                                disabled={loading}
                            />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div className="flex flex-col">
                                <label className="label-modern">Correo Institucional</label>
                                <input 
                                    type="email" 
                                    name="correo"
                                    className="input-modern"
                                    value={formData.correo}
                                    onChange={handleChange}
                                    disabled={loading}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="label-modern">Teléfono / WhatsApp</label>
                                <input 
                                    type="text" 
                                    name="numero_contacto"
                                    className="input-modern"
                                    value={formData.numero_contacto}
                                    onChange={handleChange}
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col">
                            <label className="label-modern">Asignar Rol de Usuario</label>
                            <select 
                                name="rol"
                                className="input-modern bg-gray-50 cursor-pointer"
                                value={formData.rol}
                                onChange={handleChange}
                                disabled={loading}
                            >
                                <option value="administrador">Administrador</option>
                                <option value="usuario_stock">Usuario de Stock</option>
                                <option value="retiro_mercaderia">Retiro de Mercadería</option>
                            </select>
                        </div>

                        {/* Botones de Acción */}
                        <div className="flex flex-col md:flex-row gap-3 pt-6">
                            <button 
                                type="button" 
                                className="btn-secondary-modern flex-1 order-2 md:order-1"
                                onClick={() => setEditingPerson(null)}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit" 
                                className="btn-corporate flex-1 order-1 md:order-2 py-4"
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="w-5 h-5 border-2 border-black/30 border-t-black rounded-full animate-spin"></div>
                                ) : (
                                    <>
                                        <i className="bi bi-save2-fill"></i>
                                        Guardar Cambios
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default EditPersonForm;